import { PlacementContentDef } from '@ads-ep/fetch-api-client';

export class PlacementConfig {
  id: string | null = null;
  content: PlacementContentDef;
}
